import { Component } from 'preact'
// eslint-disable-next-line import/no-internal-modules
import ButtonControl from '@insided/deprecated-preact-components/button-control'
// eslint-disable-next-line import/no-internal-modules
import { exportData } from '@insided/deprecated-control/UserOverview/DataSource'
import { DataSourceOpts } from '@insided/deprecated-control/overview'
import { CustomProfileFieldList } from '@insided/deprecated-control/UserOverview/Columns'
import AlertComponent from '@insided/deprecated-control/ui-components/AlertComponent'

 interface ExportCsvComponentProps {
     options: DataSourceOpts
     customProfileFields: CustomProfileFieldList
}

interface State {
    showExportError: boolean
    showExportInProgress: boolean
}

class ExportCsvComponent extends Component<ExportCsvComponentProps, State> {
    constructor(props: ExportCsvComponentProps) {
        super(props)
        this.state = {
            showExportError: false,
            showExportInProgress: false
        }
    }

    exportCsv = () => {
        const { options, customProfileFields } = this.props
        this.setState(
            () => ({ showExportError: false, showExportInProgress: true }), // Show success just after user clicking the export button.
            async () => await exportData(options, customProfileFields)
                .then((response) => {
                    window.location.assign(response.data)
                })
                .catch(() => {
                    this.setState({ showExportError: true, showExportInProgress: false })
                })
        )
    }

    render() {
        const { showExportError, showExportInProgress } = this.state

        return (
          <div style='display:inline'>
            <ButtonControl
              onClick={this.exportCsv}
              title='Export to CSV'
              variant='secondary'
              newStyle
              size='medium'
            />
            {showExportError && (
              <AlertComponent
                message='Something went wrong. Please try again'
                messageType='error'
                isVisibleFor={5000}
                sticky
                onTimeoutEnd={() => this.setState({ showExportError: false })}
              />
                )}
            {showExportInProgress && (
              <AlertComponent
                message='Export in progress, this can take a few seconds or up to a minute for larger groups of users.'
                messageType='success'
                isVisibleFor={5000}
                sticky
                onTimeoutEnd={() => this.setState({ showExportInProgress: false })}
              />
                )}
          </div>
        )
    }
}

export default ExportCsvComponent
